<template>
      <div :class="'cell-container' + (isSearchView ? ' in-search' : '')" v-if="!loading" :cell-type="thumbnailInfo.cellType">
        <ul :class="containerClassName">
          <li v-for="(cell, index) in cellList" :class="playNowClass(cell)" :key="cell.thumbnail + '_' + index" @click.prevent="()=>selectCell(cell)">
            <a href="#">
            <div :class="cellImgClass(cell)">
            <template v-if="isProgressCircleCell">
               <div class="circle-progress">
                 <vue-circle
                   :progress="cell.progress * 100"
                   :size="84"
                   :reverse="false"
                   line-cap="butt"
                   :fill="fill"
                   empty-fill="rgba(0, 0, 0, .3)"
                   :animation-start-value="0.0"
                   :start-angle="4.8"
                   insert-mode="append"
                   :thickness="3"
                   :show-percent="false">
                 </vue-circle>
               </div>
               <div class="circle-img">
                 <img :src="getCircleImage(cell)" :alt="altTitle(cell)"/>
               </div>
             </template>
              <template v-else>
                <img v-lazy="getLazyLoadObj(cell)" :alt="altTitle(cell)"/>
                <span class="vod-playnow" v-if="selectOn(cell, index) && bottomTab !== 'recommend'"></span>
              </template>
  <!--            <div class="tag-top tag-list" v-top-tag-list="cell.top_taglist" v-if="thumbnailInfo.typeNumber !== 3"></div>-->
              <age-tag v-if="cell.age_tag !== '' && !isProgressCircleCell && !isLikeChannel" :age-code="cell.age_tag"/>
  <!--            <div class="tag-bottom tag-list" v-if="cell.bottom_taglist.length && thumbnailInfo.typeNumber !== 3"-->
  <!--                 v-bottom-tag-list="cell.bottom_taglist"></div>-->

              <ul class="badge-list">
                <li class="left-top-area">
                  <ul>
                    <li>
                      <span class="badge artwork quick-vod">Quick VOD</span>
                    </li>
                    <li>
                      <span class="badge artwork">이벤트</span>
                    </li>
                  </ul>
                </li>
                <li class="right-top-area">
                  <span class="brand wavve">웨이브</span>
                </li>
                <li class="center-bottom-area">
                  <span class="badge artwork">bottom label</span>
                </li>
              </ul>

              <template v-if="!isProgressCircleCell">
              <div class="progress-bar" v-if="cell.progress !== ''" v-progress-bar="cell.progress * 100"></div>
              </template>
            </div>
            <div class="cell-info">
              <slot v-if="cell.rank !== '' && isNotLive">
                <div class="rank">{{cell.rank}}</div>
              </slot>
              <div class="cell-title-wrap" v-title-list="{'titleList': cell.title_list}">
              </div>
            </div></a>
          </li>
        </ul>
        <span class="scroll-none"></span>
      </div>
</template>
<script>
import { resizeThumbnail } from '@/common/image.filter'
import { progressBar, topTagList, titleList, bandTitle } from '@/common/directives'
import { getEventListByType } from '@/common/util/event.util'
import { get } from 'lodash'
import { parseUrl } from 'query-string'
import AgeTag from '@/components/tags/AgeTag'
import VueCircle from 'vue2-circle-progress/src/index.vue'
import { MENU_HOME, MENU_MY } from '@/common/menu/menu.const'
import { COOKIE_KEY_VERIFIED_ADULT, LIVE, PLAYER } from '@/common/constant'
import utils from '@/common/util/utils'
import { EventBus } from '@/components/eventbus/EventBus'
import { ON_CLICK } from '@/common/event.const'
import { getTitle } from '@/common/util/common'
import { PATH_NAME_APOLLO_PLAYER, PATH_NAME_PLAYER } from '@/common/router.const'
export default {
  name: 'CellList',
  components: { AgeTag, VueCircle },
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    },
    containerClassName: {
      type: String
    },
    contentInfo: {
      type: Object
    },
    bottomTab: {
      type: String
    },
    loading: {
      type: Boolean
    }
  },
  data () {
    return {
      component: null,
      isSearchView: false,
      routeQueryId: '',
      fill: { gradient: [['#1351f9', 1], ['#1351f9', 0]] },
      // fill: { gradient: ['#8d4fe3', '#2ac5fe'], gradientAngle: Math.PI / 4 },
      verifyAdult: false
    }
  },
  methods: {
    getLazyLoadObj (cell) {
      if (this.isPosterImage(cell)) {
        return {
          src: resizeThumbnail(cell.thumbnail, this.thumbnailInfo).replace('w320', 'w208').replace('h180', 'h296'),
          error: '/img/common/img_default_thum_1.png',
          loading: '/img/common/img_default_thum_1.png'
        }
      } else {
        return {
          src: resizeThumbnail(cell.thumbnail, this.thumbnailInfo),
          error: this.thumbnailInfo.loadingImageUrl,
          loading: this.thumbnailInfo.loadingImageUrl
        }
      }
    },
    selectCell (cell) {
      const { onNavigationEvent, onClickEvent } = getEventListByType(cell.event_list)
      if (onClickEvent) {
        EventBus.$emit(ON_CLICK, onClickEvent)
      }
      let navigationUrl = get(onNavigationEvent, 'url', '').replace('.html', '')
      let { url, query } = parseUrl(navigationUrl)
      let section = url.split('/').pop()
      if (section === 'list') {
        this.$router.push({
          name: 'channelclip',
          params: {
            uiCode: query.uicode
          }
        })
      } else {
        let pathName = this.$route.name === PATH_NAME_APOLLO_PLAYER ? PATH_NAME_APOLLO_PLAYER : PATH_NAME_PLAYER
        this.$router.push({
          name: pathName,
          params: {
            section
          },
          query: query
        })
      }
    },
    isPosterImage (cell) {
      return cell.thumbnail && cell.thumbnail.indexOf('movieImg') > -1
    },
    selectOn (cell) {
      let eventList = get(cell, 'event_list', [])
      eventList = get(eventList.filter(data => data.type === 'on-click'), '0', undefined)
      if (eventList === undefined) return
      const bodyList = get(eventList, 'bodylist', [])
      const uiCode = get(bodyList.filter(res => res.indexOf('uicode') > -1), '0', undefined)
      if (uiCode === undefined) return
      return uiCode.split(':').pop() === this.routeQueryId
    },
    getCircleImage (cell) {
      return resizeThumbnail(cell.thumbnail, { width: 168, height: 168, quality: 75, isSquare: true, multiply: 3 })
      // if (this.isPosterImage(cell)) {
      //   return resizeThumbnail(cell.thumbnail, { width: 208, height: 296, quality: 100 })
      // } else {
      //   return resizeThumbnail(cell.thumbnail, this.thumbnailInfo)
      // }
    },
    playNowClass (cell) {
      const nowChannelId = get(this.$route, ['query', 'channelid'], '')
      const url = get(cell, ['event_list', '1', 'url'], '')
      const contentId = url.split('=').pop()
      return nowChannelId !== '' && nowChannelId === contentId ? 'playnow' : ''
    },
    cellImgClass (cell) {
      const eventListUrl = get(cell, ['event_list', '1', 'url'], '')
      const type = eventListUrl.indexOf('player/movie') > -1 ? 'movie' : 'vod'
      const isDim = Number(get(cell, 'age', 0)) >= 21 && (utils.cookies.getCredential() === 'none' || this.verifyAdult)
      if (isDim) {
        return type === 'movie' ? 'cell-img adult' : 'cell-img vod-adult'
      } else {
        return 'cell-img ' + this.$route.name
      }
    },
    altTitle (cell) {
      return getTitle(cell)
    }
  },
  computed: {
    isProgressCircleCell () {
      return this.containerClassName.indexOf('cell-circle') > -1 && (this.$route.name === MENU_HOME || this.$route.name === MENU_MY)
    },
    isLikeChannel () {
      return this.containerClassName.indexOf('cell-circle') > -1 && (this.$route.name === LIVE || this.$route.name === PLAYER)
    },
    isNotLive () {
      return get(this.$route, 'params.section', '') !== 'live'
    }
  },
  directives: {
    progressBar,
    topTagList,
    titleList,
    bandTitle
  },
  created () {
    this.routeQueryId = get(this.$route.query, 'channelid', '')
    this.isSearchView = this.$route.name === 'search'
    this.verifyAdult = utils.cookies.getItem(COOKIE_KEY_VERIFIED_ADULT) !== '1'
  },
  watch: {
    contentInfo () {
      this.routeQueryId = get(this.$route.query, 'channelid', '')
    }
  }
}
</script>
<style scoped>
/*.cell-list {*/
/*background-color: #fff;*/
/*}*/
.cell-circle .cell-img.clip,
.cell-circle .cell-img.live {
  width: 84px;
  height: 84px;
}

.cell-circle .cell-img.clip img,
.cell-circle .cell-img.live img{
  width: 100%;
  height: 100%;
  margin: 0 0 0 0;
}

img[lazy=loading] {
  opacity: 0.5;
}

img[lazy=error] {
  opacity: 1;
}

img[lazy=loaded] {
  -webkit-transition: opacity 350ms ease-in-out;
  -moz-transition: opacity 350ms ease-in-out;
  -o-transition: opacity 350ms ease-in-out;
  transition: opacity 350ms ease-in-out;
}
.tag-age {
  position: absolute;
  height: 20px;
}
.progress-bar{
  display: block;
  height: 3px;
  background-color: #1351f9;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#5654e1', endColorstr='#2ac5fe', gradientType=1);
}
.circle{
  height: 84px;
}
.circle-progress {
  position: absolute;
  z-index: 100;
  width: 84px;
  height: 84px;
  border-radius: 42px;
  overflow: hidden;
}
.circle-img {
  width: 84px;
  height: 84px;
  border-radius: 42px;
  overflow: hidden;
}
/* 첫번째 vod 재생 overlay */
.vod-playnow:after{
  position: absolute;
  display: block;
  content: '';
  top: 50%;
  margin-top: -18px;
  left: 50%;
  margin-left: -18px;
  width: 36px;
  height: 36px;
  background: url(/img/common/ic-now-play.png);
  background-size: 36px 36px;
  z-index: 200;
}
.cell-img.adult {
  position: relative;
}
.cell-img.adult .tag-age{
  opacity: 0.2;
}

/*
.cell-img.adult img{
  z-index: 500 !important;
  opacity: 0.1;
  background-color: #000000;
}*/

.cell-img .adult-21{
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 46px;
  height: 46px;
}
</style>
